import { useEffect } from 'react';

export const trackTcVars = (variables = {}) => {
  window.tc_vars = window.tc_vars || {};
  Object.keys(variables).forEach((key) => {
    window.tc_vars[key] = variables[key];
  });
};

export const useTrackTMSPage = (label) => {
  useEffect(() => {
    trackTcVars({
      page_name: label,
      env_template: label,
    });
  }, [label]);
};

export const trackTMSSelectedOffer = (offerType) => {
  trackTcVars({
    prime_benefit: `${offerType === 'PRIME' ? 'true' : 'false'}`,
    user_prime_subscription: `${
      offerType === 'PRIME' ? 'subscriber' : 'non_subscriber'
    }`,
    user_prime_subscription_type: `${
      offerType === 'PRIME'
        ? 'free-trial-plus-1-months'
        : 'free-trial-permitted'
    }`,
  });
};

export const useResetTMSTracking = (isPrime) => {
  useEffect(() => {
    if (isPrime) return;
    trackTcVars({
      prime_benefit: 'false',
      user_prime_subscription: 'non_subscriber',
      user_prime_subscription_type: 'free-trial-permitted',
    });
  }, [isPrime]);
};
